function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 2C12.26 2 6 8.26 6 16C6 26.5 20 42 20 42C20 42 34 26.5 34 16C34 8.26 27.74 2 20 2ZM20 21C17.24 21 15 18.76 15 16C15 13.24 17.24 11 20 11C22.76 11 25 13.24 25 16C25 18.76 22.76 21 20 21Z",
  fill: "#1ECD96"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 42L19.2579 42.6703L20 43.4919L20.7421 42.6703L20 42ZM20 42C20.7421 42.6703 20.7423 42.6701 20.7425 42.6699L20.7432 42.6691L20.7455 42.6665L20.754 42.657L20.7859 42.6215C20.7972 42.6088 20.8108 42.5936 20.8264 42.576C20.8489 42.5507 20.8757 42.5205 20.9067 42.4854C21.0118 42.3664 21.1649 42.1916 21.3592 41.9662C21.7476 41.5153 22.3008 40.8613 22.964 40.0442C24.2893 38.4112 26.0582 36.1214 27.829 33.4968C29.5978 30.8751 31.3811 27.9011 32.7251 24.901C34.0633 21.914 35 18.8273 35 16C35 7.70772 28.2923 1 20 1C11.7077 1 5 7.70772 5 16C5 18.8273 5.93673 21.914 7.2749 24.901C8.61894 27.9011 10.4022 30.8751 12.171 33.4968C13.9418 36.1214 15.7107 38.4112 17.036 40.0442C17.6992 40.8613 18.2524 41.5153 18.6408 41.9662C18.8351 42.1916 18.9882 42.3664 19.0933 42.4854C19.1458 42.5449 19.1864 42.5905 19.2141 42.6215L19.246 42.657L19.2545 42.6665L19.2568 42.6691L19.2575 42.6699C19.2577 42.6701 19.2579 42.6703 20 42ZM20 20C17.7923 20 16 18.2077 16 16C16 13.7923 17.7923 12 20 12C22.2077 12 24 13.7923 24 16C24 18.2077 22.2077 20 20 20Z",
  stroke: "white",
  strokeWidth: 2
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.75,
  cy: 15.75,
  r: 6.25,
  fill: "#2BA37D"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 40,
  height: 52.9838,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgActiveMarker = function SvgActiveMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 53,
    viewBox: "0 0 40 53",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActiveMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/active_marker.cfc5f2e3.svg";
export { ForwardRef as ReactComponent };